export interface TemplateResponseObject {
    _id: string;
    organizationId: string;
    filerrFileId: string;
    fileType: string;
    fileName: string;
    displayName: string;
    status: 'active' | 'inactive' | 'deleted';
    createdBy: number;
    updatedBy: number;
    createdAt: string;
    updatedAt: string;
    fileUrl?: string;
    virusScanStatus?: 'in_progress' | 'passed' | 'detected';
    preview?: {
        type?: string;
        state?: string;
        open_url?: string;
        img_urls?: {
            large?: string;
            thumb_large?: string;
        };
        provider_id?: string;
        provider_name?: string;
        thumbnail_offset?: number | null;
    };
    inUse?: boolean;
}

export type GetTemplatesResponse = TemplateResponseObject[];

export interface SendTemplateResponse {
    success: boolean;
}

export enum DocumentStatus {
    SENT = 'sent',
    SIGNED = 'signed',
    EXPIRED = 'voided',
    PENDING = 'pending',
    AUTO_RESPONDED = 'autoresponded',
}

export interface StatusHistory {
    document_status: DocumentStatus;
    timestamp: string;
    envelope_id: string;
    _id: string;
}

export interface SentTemplateData {
    _id: string;
    organizationId: string;
    sellerId: number;
    createdBy: number;
    updatedBy: number;
    documentName: string;
    currentStatus: DocumentStatus;
    templateId: string;
    statusHistory: StatusHistory[];
    createdAt: string;
    updatedAt: string;
    envelopeId: string;
    createdByUsername: string;
    // TODO: extend types
}

interface StatusStats {
    status: DocumentStatus;
    count: number;
}

export interface SellerLegalDocsStats {
    statuses: StatusStats[];
    sellerId: number;
}

export interface LegalDocsStatsBySeller {
    [sellerId: string]: SellerLegalDocsStats;
}

export interface LegalDocumentsData {
    totalTemplates: number;
    activeTemplates: number;
    statsBySeller: LegalDocsStatsBySeller;
}

export type GetSellerTemplatesDataResponse = SentTemplateData[];
